<snelstart-ui-table [config]="tableConfig">
  <snelstart-ui-table-col name="bezwaarschrift" displayName="Jaar" [showFilter]="false" [showSort]="false">
    <snelstart-ui-table-col-data>
      <ng-template let-record="record">
        <ng-container *ngIf="record.bezwaarschrift?.bezwaarSpecificatie?.aanslagJaar">
          {{record.bezwaarschrift.bezwaarSpecificatie.aanslagJaar}}
        </ng-container>
      </ng-template>
    </snelstart-ui-table-col-data>
  </snelstart-ui-table-col>
  <snelstart-ui-table-col name="bezwaarschrift" displayName="Belastingmiddel" [showFilter]="false" [showSort]="false">
    <snelstart-ui-table-col-data>
      <ng-template let-record="record">
        <ng-container *ngIf="record.bezwaarschrift?.bezwaarSpecificatie?.belastingMiddel">
            <ng-container [ngSwitch]="record.bezwaarschrift?.bezwaarSpecificatie?.belastingMiddel">
                <span *ngSwitchCase="'IH'">Inkomstenbelasting</span>
                <span *ngSwitchCase="'VPB'">Vennootschapsbelasting</span>
                <span *ngSwitchCase="'OB'">Omzetbelasting</span>
                <span *ngSwitchDefault>{{ record.bezwaarschrift?.bezwaarSpecificatie?.belastingMiddel }}</span>
            </ng-container>
        </ng-container>
      </ng-template>
    </snelstart-ui-table-col-data>
  </snelstart-ui-table-col>
    <snelstart-ui-table-col name="aanslagnummer" displayName="Aanslagnummer" [showFilter]="false" [showSort]="false">
        <snelstart-ui-table-col-data>
            <ng-template let-record="record">
                <ng-container *ngIf="record.bezwaarschrift?.bezwaarSpecificatie?.aanslagnummer">
                    {{record.bezwaarschrift.bezwaarSpecificatie.aanslagnummer}}
                </ng-container>
            </ng-template>
        </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
  <snelstart-ui-table-col name="bezwaarschrift" displayName="Soort" [showFilter]="false" [showSort]="false">
    <snelstart-ui-table-col-data>
      <ng-template let-record="record">
        <ng-container *ngIf="record.bezwaarschrift?.bezwaarSpecificatie?.bezwaarSoort">
          <ng-container>
            <a *ngIf="record.bezwaarschrift.bezwaarSpecificatie.bezwaarSoort === 'ASLG'">Bezwaar tegen de aanslag</a>
            <a *ngIf="record.bezwaarschrift.bezwaarSpecificatie.bezwaarSoort === 'NHA'">Bezwaar tegen de naheffingsaanslag</a>
            <a *ngIf="record.bezwaarschrift.bezwaarSpecificatie.bezwaarSoort === 'AMBA'">Bezwaar tegen ambtshalve aanslag</a>
            <a *ngIf="record.bezwaarschrift.bezwaarSpecificatie.bezwaarSoort === 'BBB'">Bezwaar tegen boetebeschikking</a>
            <a *ngIf="record.bezwaarschrift.bezwaarSpecificatie.bezwaarSoort === 'BLSR'">Bezwaar tegen belastingrentebeschikking</a>
            <a *ngIf="record.bezwaarschrift.bezwaarSpecificatie.bezwaarSoort === 'VLBS'">Bezwaar tegen verliesbeschikking</a>
            <a *ngIf="record.bezwaarschrift.bezwaarSpecificatie.bezwaarSoort === 'NVAS'">Bezwaar tegen navorderingsaanslag</a>
            <a *ngIf="record.bezwaarschrift.bezwaarSpecificatie.bezwaarSoort === 'OVER'">Algemeen bezwaar</a>
          </ng-container>
        </ng-container>
      </ng-template>
    </snelstart-ui-table-col-data>
  </snelstart-ui-table-col>
  <snelstart-ui-table-col name="submissionDate" displayName="Datum ingediend" [showFilter]="false" [showSort]="false">
    <snelstart-ui-table-col-data>
      <ng-template let-datumIngediend>
        <ng-container>
          <a *ngIf="datumIngediend	=== undefined">-</a>
        </ng-container>
        {{ datumIngediend | date: 'dd-MM-yyyy' }}
      </ng-template>
    </snelstart-ui-table-col-data>
  </snelstart-ui-table-col>
    <snelstart-ui-table-col name="attachment" displayName="Bijlage" columnType="string" [showFilter]="false" [showSort]="false">
        <snelstart-ui-table-col-data>
            <ng-template let-attachment>
                <ng-container *ngIf="attachment !== undefined && attachment">
             <span snelstartUiTooltip="Klik om te openen">
                <snelstart-ui-icon name="paperclip"></snelstart-ui-icon>
              </span>
                </ng-container>
            </ng-template>
        </snelstart-ui-table-col-data>
    </snelstart-ui-table-col>
</snelstart-ui-table>
